import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import * as _ from 'lodash';

/**
 * Generated class for the FormatDatetimePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatDatetime',
})
export class FormatDatetimePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    let val: any = value;

    if (args[1] === 'seconds') {
      // in timestamp in seconds // convert to number
      val = _.parseInt(value) * 1000;
    }
    if (args[0] == 'messageList') {
      if (moment(val) > moment().startOf('day')) {
        return moment(val).format('h:mma');
      } else if (moment(val) > moment().subtract(1, 'day').startOf('day')) {
        return 'Yesterday, ' + moment(val).format('h:mma');
      } else {
        return moment(val).format('M/D/YY, h:mma');
      }
    } else if (args[0] === 'ago') {
      let v = moment(val).fromNow();
      if (v.length > 11) {
        v = v.replace(' ago', '');
      }
      return v;
    } else if (args[0] === 'condensed') {
      const date = moment(val);

      if (date > moment().subtract(3, 'minutes')) {
        return 'Now';
      } else if (date > moment().subtract(1, 'hour')) {
        return moment().diff(date, 'minutes') + 'm';
      } else if (date > moment().subtract(1, 'day')) {
        return moment().diff(date, 'hours') + 'h';
      } else if (date > moment().subtract(7, 'days')) {
        return moment().diff(date, 'days') + 'd';
      } else if (date > moment().subtract(1, 'year')) {
        return date.format('MMM D');
      } else {
        return date.format('M/D/YY');
      }
    } else if (args[0]) {
      return moment(val).format(args[0]);
    } else {
      return moment(val).fromNow();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-datetime/format-datetime.ts